import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';


const COLORS = {
  purple: "#8B5CF6",
  pink: "#EC4899",
  gray: "#9CA3AF",
  black: "#1F2937",
};

const StyledIGamingOffer = styled(Box)(({ theme }) => ({
  // minHeight: 'calc(300vh - 82px)',
  // position: 'relative',
  overflow: 'visible',
  width: '100%',
  '& .homeBg': {
    // position: 'absolute',
    height: '100%',
    width: '100%',
    // background: 'red',

    '& .videoElement': {
      // position: 'absolute',
      top: 0,
      left: 0,
      height: '130%',
      width: '100%',
      objectFit: 'cover',
      zIndex: -1,
    },
  },

  '& .homeContent': {
    // position: 'absolute',
    height: '100%',
    width: '100%',
    zIndex: 1 /* Ensures content is above the video */,
    // display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(20),
    // paddingLeft: '20%',
    // padding: '7% 17.7% 12% 17.7%',
    // padding: '7% 17.7% 3% 17.7%',
    padding: '2% 10% 5% 10% !important',
    // background: 'linear-gradient(to bottom, black, gray, white)',
    // background: 'linear-gradient(180deg, #000000 48.02%, #FFFFFF 101%)',


    '& .bannerText': {
      background: theme.customGradients.primary,
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      boxShadow: theme.palette.boxShadow.secondary,
      font: theme.typography.h3.font,
      fontWeight: 400,
      textAlign: 'center',
    },

    [theme.breakpoints.down('lg')]: {
      paddingLeft: 1,
      '& .iconBrandLogo': {
        width: '300px',
        height: '100px',
      },
    },
  },

  [theme.breakpoints.down('lg')]: {
    // minHeight: '200vh',
    margin: theme.spacing(0),

    '& .wave': {
      display: 'none !important'
    },

    '& .label2': {
      justifyContent: 'center',
      '@media (width: 320px)': {
        fontSize: '12px !important',
      },
      '@media (width: 344px)': {
        fontSize: '13px !important',
      },
      '@media (width: 360px)': {
        fontSize: '14px !important',
      },
      '@media (width: 375px)': {
        fontSize: '15px !important',
      },
      '@media (width: 390px)': {
        fontSize: '15.5px !important',
      },
      '@media (width: 412px)': {
        fontSize: '16.5px !important',
      },
      '@media (width: 414px)': {
        fontSize: '16.5px !important',
      },
      '@media (width: 430px)': {
        fontSize: '17px !important',
      },
    },

    '& .homeContent': {
      marginTop: theme.spacing(0),
      justifyContent: 'center',
      padding: '40px 10px 10px 10px !important',

      '& .bannerText': {
        margin: theme.spacing(0, 1),
        font: theme.typography.h6.font,
        fontWeight: `${500} !important`,
      },
    },
  },
}));

export default StyledIGamingOffer;
